import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { useTranslator } from '@/hooks/useTranslator';
import { SsoOnboardingShell } from '../../-components/SsoOnboardingShell';
import { SsoTestResultView } from '../../-components/SsoTestResultView';
import { useSsoTestResult } from '../../-hooks/useSsoTestResult';

const searchSchema = z.object({
  status: z.enum(['success', 'failed']).catch('failed'),
  email: z.string().optional(),
  reason: z.string().optional(),
});

/** Where the backend sends the browser after an onboarding test sign-in. */
export const Route = createFileRoute('/sso-onboarding/(pages)/test-result/')({
  validateSearch: searchSchema,
  component: SsoTestResultPage,
});

function SsoTestResultPage() {
  const { getTranslation: t } = useTranslator({ page: 'ssoOnboarding' });
  const { status, email, reason } = Route.useSearch();
  const { token } = useSsoTestResult();

  return (
    <SsoOnboardingShell title={t('result.title')}>
      <SsoTestResultView
        status={status}
        email={email}
        reason={reason}
        token={token}
      />
    </SsoOnboardingShell>
  );
}
